import { render, staticRenderFns } from "./evaluation.vue?vue&type=template&id=679a4751&scoped=true"
import script from "./evaluation.vue?vue&type=script&lang=ts"
export * from "./evaluation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a4751",
  null
  
)

export default component.exports